import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { PageTransition } from '../animations/PageTransition';
import { FaPhoneAlt } from 'react-icons/fa';
import { IoIosMail, IoIosPin, IoIosPhonePortrait } from 'react-icons/io';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { BsArrowRight } from 'react-icons/bs';
import { FaPersonWalkingLuggage } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

export const Contact = ({ transition }) => {
	return (
		<>
			<Helmet>
				<title>Contact & Booking – Spring Studio Stockholm</title>
				<meta
					name="description"
					content="Get in touch with Spring Studio to book the studio or ask questions about availability, pricing, and productions. Located in Aspudden/Örnsberg, Stockholm."
				/>
				<meta property="og:title" content="Contact & Booking – Spring Studio Stockholm" />
				<meta property="og:description" content="Get in touch with Spring Studio to book the studio or ask questions about availability, pricing, and productions in Stockholm." />
				<link rel="canonical" href="https://springstudio.se/contact" />
			</Helmet>
			<PageTransition />
			<motion.main className="contact-page" exit={{ opacity: 0 }} transition={transition}>
				<section className="section section-contact-hero">
					<div className="row">
						<div className="col col-7">
							<div className="module-text">
								<h1 className="studio-single-hero-header-title" data-text={'Contact'}>
									Contact
								</h1>
								<p className="lg">
									Whether you’re planning a photoshoot, film production, rehearsal, or just want to know more about the studio, feel free to get in touch. We’re happy to answer
									questions, check availability, or discuss how the space can work for your project.
								</p>
							</div>
							<div className="module-image">
								<picture>
									<source
										type="image/webp"
										srcSet="
										/assets/img/generated/contact/hero-640.webp 640w,
										/assets/img/generated/contact/hero-960.webp 960w,
										/assets/img/generated/contact/hero-1280.webp 1280w,
										/assets/img/generated/contact/hero-1920.webp 1920w,
										/assets/img/generated/contact/hero-2560.webp 2560w
										"
										sizes="100vw"
									/>

									<source
										type="image/jpeg"
										srcSet="
										/assets/img/generated/contact/hero-640.jpg 640w,
										/assets/img/generated/contact/hero-960.jpg 960w,
										/assets/img/generated/contact/hero-1280.jpg 1280w,
										/assets/img/generated/contact/hero-1920.jpg 1920w,
										/assets/img/generated/contact/hero-2560.jpg 2560w
    									"
										sizes="100vw"
									/>

									<img src="/assets/img/generated/hero/hero-1280.jpg" alt="Spring Studio interior" loading="lazy" decoding="async" />
								</picture>
							</div>
						</div>
						<div className="col col-5">
							<div className="module-text">
								<h2 class="h1" data-text="Contact info">
									Contact info
								</h2>
								<div className="contact-info mail">
									<h3 className="h5">
										<IoIosMail />
										Mail
									</h3>
									<a href="mailto:janne@springstudio.se" target="_blank" rel="noreferrer" className="sm">
										janne@springstudio.se
									</a>
								</div>
								<div className="contact-info phone">
									<h3 className="h5">
										<FaPhoneAlt />
										Phone
									</h3>
									<a href="tel:0046707467233" target="_blank" rel="noreferrer" className="sm">
										0707467233
									</a>
								</div>
								<div className="contact-info address">
									<h3 className="h5">
										<IoIosPin />
										Spring Studio
									</h3>
									<a href="https://maps.app.goo.gl/Nv89i1ivAesHQNt59" target="_blank" rel="noreferrer">
										<p className="sm">Instrumentvägen 29</p>
										<p className="sm">126 53 Örnsberg, Stockholm</p>
									</a>
								</div>
								<div className="contact-info travel">
									<h3 className="h5">
										<FaPersonWalkingLuggage />
										Getting here
									</h3>
									<p className="sm">
										Spring Studio is located in Aspudden/Örnsberg, just a three-minute walk from Örnsbergs metro station. Örnsbergs badplats and the Vinterviken area are only a
										short walk away, offering waterfront surroundings and a calm, inspiring environment.
									</p>
								</div>
								<div className="contact-info social">
									<h3 className="h5">
										<IoIosPhonePortrait />
										Follow us on
									</h3>
									<p className="sm">For behind-the-scenes content, recent productions, and updates from the studio, follow us on social media.</p>
									<div className="social-links">
										<a href="https://facebook.com/SpringStudioSwe" aria-label="Facebook" target="_blank" rel="noreferrer">
											<FaFacebook />
										</a>
										<a href="https://www.instagram.com/springstudiostockholm_/" aria-label="Instagram" target="_blank" rel="noreferrer">
											<FaInstagram />
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section className="section section-contact">
					<div className="row theme-dark">
						<div className="col col-6">
							<div className="module-text">
								<h2 className="fade d1" data-text={'Ready to book the studio?'}>
									Ready to book the studio?
								</h2>
								<p className="fade sm">Send us an email with your dates, type of production, and any questions you might have. We’ll get back to you as soon as possible.</p>
							</div>
						</div>

						<div className="col col-6">
							<div className="button-wrapper">
								<a href="mailto:janne@springstudio.se" target="_blank" rel="noreferrer" className="btn btn-primary">
									Email us
								</a>
								<Link to="/studio" className="btn btn-secondary">
									View the studio <BsArrowRight />
								</Link>
							</div>
						</div>
					</div>
				</section>
			</motion.main>
		</>
	);
};
